// @flow
import ResourceModel from "../base/ResourceModel";

import type { ModularUIResponse } from "../../modularui";

/**
 * User model
 */
export default class UserModel extends ResourceModel {
  /**
   */
  get type(): string {
    return "User";
  }

  /**
   */
  static get modelName(): string {
    return "UserModel";
  }

  /**
   */
  static isApplicableModel(data: ModularUIResponse): boolean {
    return (
      data.contributions.resourcetype &&
      data.contributions.resourcetype === "userdata"
    );
  }

  /**
   * Retrieve avatar of user
   */
  get avatar(): string | null {
    return this.data.Avatar;
  }

  /**
   * Retrieve username of user
   */
  get username(): string {
    return this.data.Username || "Guest";
  }

  /**
   * retrieve the fullname of the user
   */
  get fullname(): string {
    return this.data.Fullname || "Guest";
  }

  /**
   */
  get label(): string {
    return this.contributions.label;
  }
}
